/* La franja de marcas corre siempre: no se pausa al pasar el raton.
   El arranque/parada del bucle lo controla solo el CSS (animation-play-state). */



(function(){
  var raiz = document.documentElement;
  var quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  raiz.classList.add('js');

  var ojo = new IntersectionObserver(function(filas){
    filas.forEach(function(f){
      if(!f.isIntersecting) return;
      f.target.classList.add('dentro');
      ojo.unobserve(f.target);
    });
  }, { rootMargin:'0px 0px -12% 0px', threshold:.08 });
  document.querySelectorAll('.revela').forEach(function(el){ ojo.observe(el); });

  // Red de seguridad: si el scroll salta (tecla Fin, un ancla, volver atrás) el
  // observador no dispara y el bloque se quedaría invisible para siempre.
  var rescatar = function(){
    document.querySelectorAll('.revela:not(.dentro)').forEach(function(el){
      if(el.getBoundingClientRect().top < innerHeight * 1.4) el.classList.add('dentro');
    });
  };
  addEventListener('scroll', rescatar, { passive:true });
  addEventListener('load', function(){ setTimeout(rescatar, 250); });
  setTimeout(rescatar, 1200);

  // Cada grupo escalona a sus hijos para que entren en cascada, no en bloque.
  document.querySelectorAll('[data-cascada]').forEach(function(grupo){
    var crudo = Number(grupo.dataset.cascada);
    var paso = Number.isFinite(crudo) ? crudo : 70;
    Array.prototype.forEach.call(grupo.children, function(hijo, i){
      hijo.style.setProperty('--d', (i * paso) + 'ms');
    });
  });

  // Contadores: se animan una sola vez, al entrar en pantalla.
  var suave = function(t){ return 1 - Math.pow(1 - t, 3); };
  var ojoNum = new IntersectionObserver(function(filas){
    filas.forEach(function(f){
      if(!f.isIntersecting) return;
      var el = f.target, meta = Number(el.dataset.hasta);
      if(!Number.isFinite(meta)) { ojoNum.unobserve(el); return; }
      var dec = (el.dataset.dec|0), ini = performance.now(), dur = quieto ? 0 : 1100;
      ojoNum.unobserve(el);
      (function paso(ahora){
        var t = dur ? Math.min(1, (ahora - ini) / dur) : 1;
        el.textContent = (meta * suave(t)).toLocaleString('es-CO',
          { minimumFractionDigits:dec, maximumFractionDigits:dec });
        if(t < 1) requestAnimationFrame(paso);
      })(ini);
    });
  }, { threshold:.6 });
  document.querySelectorAll('[data-hasta]').forEach(function(el){ ojoNum.observe(el); });

  // Botón de pausa de la cinta: sin él la animación en bucle no tiene control.
  var pausa = document.querySelector('.pausa');
  if(pausa){
    pausa.addEventListener('click', function(){
      var activo = pausa.getAttribute('aria-pressed') === 'true';
      pausa.setAttribute('aria-pressed', String(!activo));
      pausa.textContent = activo ? 'II' : '▶';
      pausa.setAttribute('aria-label', activo ? 'Pausar los mensajes' : 'Reanudar los mensajes');
    });
  }

  // El botón de WhatsApp se aparta mientras se desplaza para no tapar controles,
  // y vuelve en cuanto el scroll se detiene.
  var wa = document.querySelector('.flotante');
  if(wa){
    var reloj, aLaVista = 0;
    var refrescar = function(){ wa.classList.toggle('apartado', aLaVista > 0); };

    // No tiene sentido ofrecer el atajo cuando el destino ya está en pantalla:
    // el pie con sus datos de contacto, o un botón de WhatsApp del contenido.
    var destinos = [].slice.call(document.querySelectorAll('footer, a[href*="wa.me"]'))
      .filter(function(el){ return !el.closest('.flotante'); });
    if(destinos.length){
      var ojoWa = new IntersectionObserver(function(filas){
        filas.forEach(function(f){ aLaVista += f.isIntersecting ? 1 : -1; });
        if(aLaVista < 0) aLaVista = 0;
        refrescar();
      }, { threshold:0 });
      destinos.forEach(function(el){ ojoWa.observe(el); });
    }

    addEventListener('scroll', function(){
      wa.classList.add('apartado');
      clearTimeout(reloj);
      reloj = setTimeout(refrescar, 420);
    }, { passive:true });
  }

  // Cabecera: se compacta apenas arranca el scroll.
  var cab = document.querySelector('[data-cabecera]');
  if(cab){
    var mirar = function(){ cab.classList.toggle('encogida', scrollY > 30); };
    addEventListener('scroll', mirar, { passive:true });
    mirar();
  }
})();



/* Lo que todavía no está conectado lo dice en voz alta (role=status) en lugar
   de tragarse la pulsación en silencio.
   El observador que escondía el botón flotante murió con el botón: la barra de
   contacto ocupa un carril propio, no se le pone encima a nada y por eso nunca
   se esconde. Antes, al esconderse, dejaba un enlace enfocable con opacity:0 y
   pointer-events:none como última parada de Tab en las 6 pantallas. */
(function(){
  var cartel = document.querySelector('[data-aviso-vivo]');

  // Buscador plegado tras la lupa en el corte móvil.
  var lupa = document.querySelector('[data-lupa]');
  var buscador = document.getElementById('buscador');
  if(lupa && buscador){
    lupa.addEventListener('click', function(){
      var abierto = buscador.classList.toggle('abierto');
      lupa.setAttribute('aria-expanded', String(abierto));
      if(abierto) buscador.querySelector('input').focus();
    });
  }

  var soltar = null;
  var avisar = function(texto){
    if(!cartel) return;
    cartel.textContent = texto;
    cartel.classList.add('puesto');
    clearTimeout(soltar);
    soltar = setTimeout(function(){ cartel.classList.remove('puesto'); }, 5200);
  };
  document.addEventListener('click', function(ev){
    var quien = ev.target.closest('[data-aviso]');
    if(!quien || quien.tagName === 'FORM') return;
    ev.preventDefault();
    avisar(quien.dataset.aviso);
  });
  document.addEventListener('submit', function(ev){
    var forma = ev.target.closest('[data-aviso]');
    if(!forma) return;
    ev.preventDefault();
    avisar(forma.dataset.aviso);
  });
  /* Atributo aparte y evento 'change', no 'click': los filtros y el orden SÍ
     deben marcarse y desplegarse. Con data-aviso el manejador de arriba haría
     preventDefault y la casilla no se marcaría ni el <details> se abriría; el
     aviso llega igual, después del cambio. */
  document.addEventListener('change', function(ev){
    var quien = ev.target.closest('[data-aviso-cambio]');
    if(quien) avisar(quien.dataset.avisoCambio);
  });
})();



(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var capas = [].slice.call(document.querySelectorAll('[data-parallax]'));
  if (!capas.length) return;
  var pedido = false;
  var pintar = function(){
    pedido = false;
    var y = scrollY;
    capas.forEach(function(c){
      c.style.transform = 'translate3d(0,' + (y * (parseFloat(c.dataset.parallax)||0.2)).toFixed(1) + 'px,0)';
    });
  };
  addEventListener('scroll', function(){ if(!pedido){ pedido = true; requestAnimationFrame(pintar); } },
    { passive:true });
  pintar();
})();



  (document.fonts ? document.fonts.ready : Promise.resolve())
    .then(function(){ requestAnimationFrame(function(){ document.body.classList.add('cargado'); }); });







(function(){
  var tabs=document.querySelectorAll('[data-product-tabs]');
  tabs.forEach(function(box){
    var buttons=box.querySelectorAll('[data-tab-target]');
    var panels=box.querySelectorAll('[data-tab-panel]');
    if(!buttons.length || !panels.length) return;
    function activate(name){
      buttons.forEach(function(b){
        var on=b.dataset.tabTarget===name;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p){
        p.classList.toggle('active', p.dataset.tabPanel===name);
      });
    }
    buttons.forEach(function(b){ b.addEventListener('click', function(){ activate(b.dataset.tabTarget); }); });
    activate(buttons[0].dataset.tabTarget);
  });

  var slider=document.querySelector('[data-hero-slider]');
  if(!slider) return;
  var slides=slider.querySelectorAll('.hero-slide');
  var puntos=slider.querySelector('[data-hero-puntos]');
  if(!slides.length || !puntos) return;
  var i=0, timer=null, loaded=false;
  var n=slides.length;

  function sizeToSlide(){
    var active = slides[i] && slides[i].querySelector('img');
    if(!active) return;
    var r = active.naturalWidth && active.naturalHeight ? (active.naturalHeight / active.naturalWidth) : 0.5;
    var w = slider.clientWidth || 0;
    if(!w) return;
    var h = Math.max(220, Math.min(560, Math.round(w * r)));
    slider.style.height = h + 'px';
  }

  function bindImages(){
    slides.forEach(function(slide){
      var img = slide.querySelector('img');
      if(!img) return;
      if(img.complete && img.naturalWidth){ loaded = true; return; }
      img.addEventListener('load', function(){ loaded = true; sizeToSlide(); }, { once:true });
    });
  }

  // crear puntos
  for(var k=0;k<n;k++){
    var b=document.createElement('button');
    b.setAttribute('aria-label','Ir a imagen '+(k+1));
    if(k===0)b.className='activo';
    b.addEventListener('click',(function(idx){return function(){ir(idx);reiniciar();};})(k));
    puntos.appendChild(b);
  }
  var dots=puntos.querySelectorAll('button');
  function ir(idx){
    slides[i].classList.remove('activo');
    dots[i].classList.remove('activo');
    i=(idx+n)%n;
    slides[i].classList.add('activo');
    dots[i].classList.add('activo');
    sizeToSlide();
  }
  function siguiente(){ir(i+1);}
  function anterior(){ir(i-1);}
  function reiniciar(){
    if(n < 2) return;
    if(timer)clearInterval(timer);
    timer=setInterval(siguiente,4500);
  }
  var prev=slider.querySelector('[data-hero-prev]'),next=slider.querySelector('[data-hero-next]');
  if(prev)prev.addEventListener('click',function(){anterior();reiniciar();});
  if(next)next.addEventListener('click',function(){siguiente();reiniciar();});
  slider.addEventListener('mouseenter',function(){if(timer)clearInterval(timer);});
  slider.addEventListener('mouseleave',function(){reiniciar();});
  bindImages();
  sizeToSlide();
  addEventListener('resize', sizeToSlide, { passive:true });
  reiniciar();
})();



(function(){
  var burguer=document.querySelector('[data-menu-burguer]');
  var menu=document.querySelector('.menu-cat-raiz');
  if(!burguer||!menu) return;
  burguer.addEventListener('click',function(){
    var abierto=menu.classList.toggle('abierto');
    burguer.setAttribute('aria-expanded',abierto?'true':'false');
    burguer.textContent=abierto?'✕':'☰';
  });
  menu.querySelectorAll('.menu-cat.tiene-submenu > .menu-cat-boton').forEach(function(link){
    link.addEventListener('click', function(ev){
      if(window.matchMedia('(max-width: 900px)').matches){
        var li=link.closest('.menu-cat');
        if(li){
          var abierto=li.classList.toggle('abierto');
          link.setAttribute('aria-expanded',abierto?'true':'false');
          if(abierto){ ev.preventDefault(); }
        }
      }
    });
  });
  document.addEventListener('click',function(e){
    if(!menu.contains(e.target)&&!burguer.contains(e.target)){menu.classList.remove('abierto');burguer.setAttribute('aria-expanded','false');burguer.textContent='☰';menu.querySelectorAll('.menu-cat.abierto').forEach(function(li){li.classList.remove('abierto');});}
  });
})();

/* Carriles de categorias y destacados: flechas siempre habilitadas que rebobinan
   en ambos sentidos (loop infinito). No hay autoplay: solo la franja de marcas
   avanza sola. El contenido de cada pista está duplicado para que el bucle sea
   continuo hacia adelante y hacia atras. */
(function(){
  document.querySelectorAll('[data-carril]').forEach(function(carril){
    var pista=carril.querySelector('[data-carril-pista]');
    var atras=carril.querySelector('[data-carril-atras]');
    var adelante=carril.querySelector('[data-carril-adelante]');
    if(!pista || !atras || !adelante) return;
    var max=function(){ return pista.scrollWidth - pista.clientWidth; };
    function paso(){ return Math.max(240, pista.clientWidth * 0.8); }
    function irA(x){
      x=Math.max(0, Math.min(x, max()));
      pista.scrollTo({left:x, behavior:'smooth'});
    }
    /* En carrusel infinito el usuario puede ir siempre hacia adelante/atras */
    atras.disabled=false; adelante.disabled=false;
    atras.addEventListener('click', function(){
      var destino=pista.scrollLeft - paso();
      if(destino < 0) destino = max(); /* antes del inicio -> salta al final */
      irA(destino);
    });
    adelante.addEventListener('click', function(){
      var destino=pista.scrollLeft + paso();
      if(destino > max()) destino = 0; /* pasada la duplicacion -> vuelve al inicio */
      irA(destino);
    });
  });
})();


/* Página de producto: paso de cantidad antes de agregar al carrito */
(function(){
  var caja=document.querySelector('[data-paso-caja]');
  if(!caja) return;
  var out=caja.querySelector('[data-cuantos]');
  var input=document.querySelector('[data-cantidad-input]');
  var n=1;
  caja.querySelectorAll('[data-paso]').forEach(function(b){
    b.addEventListener('click',function(){
      n=Math.max(1, n + parseInt(b.dataset.paso,10));
      out.textContent=n;
      if(input) input.value=n;
    });
  });
})();


/* Página de producto: galería (miniaturas + lightbox) y selección de variante.
   Antes la ficha solo mostraba la imagen principal, sin forma de pasar las
   fotos ni de ampliarlas, y las pastillas de color eran botones inertes: el
   carrito siempre agregaba la primera variante disponible. */
(function(){
  var galeria=document.querySelector('[data-galeria]');
  var principal=galeria && galeria.querySelector('[data-imagen-principal]');
  var minis=galeria ? galeria.querySelectorAll('[data-mini]') : [];
  var variantesEl=document.querySelector('[data-variantes]');
  var idInput=document.querySelector('[name="id"]');
  var precio=document.querySelector('[data-precio]');
  var avisoIva=document.querySelector('[data-iva-incluido]');
  var existencia=document.querySelector('[data-existencia]');
  var btn=document.querySelector('[data-agregar-btn]');
  var lupa=document.querySelector('[data-amplia]');
  var lupaImg=lupa && lupa.querySelector('[data-amplia-img]');
  var seleccion={};

  function urlGrande(u){ return u ? u.replace(/width=\d+/,'width=1600') : u; }

  /* Miniaturas: al hacer click se muestra esa foto en grande. */
  if(principal && minis.length){
    minis.forEach(function(m){
      m.addEventListener('click',function(){
        minis.forEach(function(x){ x.classList.remove('activa'); });
        m.classList.add('activa');
        var img=m.querySelector('img');
        principal.src=img.src.replace(/width=\d+/,'width=900');
      });
    });
  }

  /* Lightbox: click en la imagen principal la amplía a pantalla completa. */
  if(principal && lupa && lupaImg){
    principal.addEventListener('click',function(){
      lupaImg.src=urlGrande(principal.src);
      lupa.hidden=false;
      document.body.style.overflow='hidden';
    });
    function cerrar(){ lupa.hidden=true; document.body.style.overflow=''; }
    var cerrarBtn=lupa.querySelector('[data-amplia-cerrar]');
    if(cerrarBtn) cerrarBtn.addEventListener('click',cerrar);
    lupa.addEventListener('click',function(ev){ if(ev.target===lupa) cerrar(); });
    document.addEventListener('keydown',function(ev){ if(ev.key==='Escape') cerrar(); });
  }

  /* Variantes: al elegir un color/talla se actualiza id, precio, disponibilidad
     y la imagen principal (si la variante trae foto propia). */
  if(!variantesEl) return;
  var variantes;
  try{ variantes=JSON.parse(variantesEl.textContent); }catch(e){ return; }

  document.querySelectorAll('[data-opcion][aria-pressed="true"]').forEach(function(p){
    seleccion[p.dataset.opcion]=p.dataset.valor;
  });

  function aplicar(){
    var v=variantes.find(function(v){
      return v.opciones.every(function(o){ return seleccion[o.nombre]===o.valor; });
    });
    if(!v){
      if(avisoIva) avisoIva.hidden=true;
      return;
    }
    if(idInput) idInput.value=v.id;
    if(precio) precio.textContent=v.precio;
    if(avisoIva) avisoIva.hidden=!(v.taxable && avisoIva.dataset.impuestosIncluidos==='true');
    if(existencia){
      existencia.textContent=v.available
        ? 'En existencia y con repuestos en tienda.'
        : 'Agotado. Escríbenos para encargos.';
      existencia.style.color=v.available ? '' : 'var(--tinta-suave)';
    }
    if(btn){
      btn.disabled=!v.available;
      btn.textContent=v.available ? 'Agregar al carrito' : 'Agotado';
    }
    if(v.image && principal){
      principal.src=v.image;
      if(minis.length){
        var base=v.image.split('?')[0];
        minis.forEach(function(m){
          var img=m.querySelector('img');
          m.classList.toggle('activa', img.src.indexOf(base)>-1);
        });
      }
    }
  }

  document.querySelectorAll('[data-opcion]').forEach(function(p){
    p.addEventListener('click',function(){
      seleccion[p.dataset.opcion]=p.dataset.valor;
      document.querySelectorAll('[data-opcion]').forEach(function(x){
        if(x.dataset.opcion===p.dataset.opcion){
          x.setAttribute('aria-pressed', x.dataset.valor===p.dataset.valor ? 'true' : 'false');
        }
      });
      aplicar();
    });
  });
})();


/* Formulario de inscripción EstetiCan: valida y redirige a WhatsApp */
(function(){
  var forma=document.querySelector('[data-forma]');
  if(!forma) return;
  var gracias=document.querySelector('.forma-gracias');
  forma.addEventListener('submit',function(ev){
    ev.preventDefault();
    var d=new FormData(forma);
    var nombre=(d.get('nombre')||'').trim();
    var wa=(d.get('whatsapp')||'').trim();
    if(!nombre || !wa){ return; }
    var msg='Hola, quiero inscribirme en el curso de EstetiCan.%0A%0ANombre: '+encodeURIComponent(nombre)
      +'%0AWhatsApp: '+encodeURIComponent(wa)
      +'%0ACiudad: '+encodeURIComponent((d.get('ciudad')||'').trim())
      +'%0AExperiencia: '+encodeURIComponent(d.get('experiencia')||'');
    if(gracias){
      gracias.hidden=false;
      gracias.innerHTML='<b>¡Listo, '+nombre.replace(/[<>&]/g,'')+'!</b> Te llevamos a WhatsApp para terminar la inscripción.';
      gracias.focus();
    }
    setTimeout(function(){ window.open('https://wa.me/573104480847?text='+msg,'_blank'); }, 900);
  });
})();


/* Filtros y orden de la colección por AJAX (Section Rendering API de Shopify).
   Antes cada checkbox hacía un submit real: recarga completa, el scroll volvía
   arriba y la página parpadeaba. Ahora se pide SOLO la sección y se sustituye en
   el sitio: sin recarga, sin perder el scroll y con la URL actualizada por
   pushState (compartible y con atrás/adelante funcionando). */
(function(){
  var filtros = document.querySelector('.con-filtros');
  if(!filtros) return;

  var envoltorio = filtros.closest('[id^="shopify-section-"]');
  if(!envoltorio) return;
  var idSeccion = envoltorio.id.replace('shopify-section-','');

  function pintar(html, url, empujar){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nueva = doc.getElementById(envoltorio.id);
    if(!nueva) return false;
    // El contenido llega sin la clase de entrada; sin esto quedaría invisible.
    nueva.querySelectorAll('.revela').forEach(function(el){ el.classList.add('dentro'); });
    envoltorio.replaceWith(nueva);
    envoltorio = nueva;
    // HTML injected by the swap does not execute scripts: re-arm the price slider.
    if(window.LTPQrangos) window.LTPQrangos(nueva);
    if(empujar) history.pushState({}, '', url);
    return true;
  }

  function cargar(url, empujar){
    var pedir = new URL(url, location.origin);
    pedir.searchParams.set('section_id', idSeccion);
    filtros.classList.add('cargando');
    fetch(pedir.toString(), {headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if(!html || !pintar(html, url, empujar)) location.href = url; // red de seguridad
      })
      .catch(function(){ location.href = url; })
      .finally(function(){ document.querySelector('.con-filtros')?.classList.remove('cargando'); });
  }

  // Filtros: cualquier submit del formulario (checkbox con requestSubmit).
  document.addEventListener('submit', function(ev){
    var forma = ev.target.closest('.filtros-forma');
    if(!forma) return;
    ev.preventDefault();
    var q = new URLSearchParams(new FormData(forma)).toString();
    cargar(forma.getAttribute('action') + (q ? '?' + q : ''), true);
  });

  // Orden: el <select data-orden> reemplaza el viejo location.href.
  document.addEventListener('change', function(ev){
    var sel = ev.target.closest('[data-orden]');
    if(!sel) return;
    var u = new URL(location.href);
    if(sel.value) u.searchParams.set('sort_by', sel.value);
    else u.searchParams.delete('sort_by');
    u.searchParams.delete('page'); // al reordenar se vuelve a la primera página
    cargar(u.pathname + '?' + u.searchParams.toString(), true);
  });

  // Atrás/adelante del navegador: se repinta sin recargar.
  addEventListener('popstate', function(){ cargar(location.href, false); });
})();


/* Price range slider (two handles) for the collection price filter.
   The real Shopify params (filter.v.price.gte / .lte) live in hidden inputs;
   the visible ranges only drive them. Submits on `change` (mouse/touch release),
   NOT on `input`, so dragging does not fire one request per pixel. At either
   bound the hidden input is disabled, so the param is omitted from the URL and
   the filter reads as inactive. Exposed as window.LTPQrangos because the AJAX
   section swap injects fresh HTML that never runs its own scripts. */
window.LTPQrangos = function(raiz){
  (raiz || document).querySelectorAll('[data-rango]').forEach(function(caja){
    if(caja.dataset.listo) return;
    var lo = caja.querySelector('[data-min]'), hi = caja.querySelector('[data-max]');
    var gte = caja.querySelector('[data-gte]'), lte = caja.querySelector('[data-lte]');
    if(!lo || !hi || !gte || !lte) return;
    caja.dataset.listo = '1';

    var relleno = caja.querySelector('[data-relleno]');
    var tMin = caja.querySelector('[data-txt-min]'), tMax = caja.querySelector('[data-txt-max]');
    var tope = Number(caja.dataset.tope) || Number(hi.max) || 0;
    if(!tope) return;

    function pesos(n){ return '$' + n.toLocaleString('es-CO'); }

    function pintar(){
      var a = Number(lo.value), b = Number(hi.value);
      if(a > b){ // the handles must never cross
        if(document.activeElement === lo){ b = a; hi.value = b; }
        else { a = b; lo.value = a; }
      }
      gte.disabled = a <= 0;
      lte.disabled = b >= tope;
      gte.value = a;
      lte.value = b;
      if(tMin) tMin.textContent = pesos(a);
      if(tMax) tMax.textContent = pesos(b);
      if(relleno){
        relleno.style.left = (a / tope * 100) + '%';
        relleno.style.right = (100 - b / tope * 100) + '%';
      }
    }

    function soltar(){
      var forma = caja.closest('form');
      if(!forma) return;
      // requestSubmit fires the submit event the AJAX handler intercepts; with no
      // JS at all it falls back to a normal submit.
      if(forma.requestSubmit) forma.requestSubmit();
      else forma.submit();
    }

    ['input','change'].forEach(function(ev){
      lo.addEventListener(ev, pintar);
      hi.addEventListener(ev, pintar);
    });
    lo.addEventListener('change', soltar);
    hi.addEventListener('change', soltar);
    pintar();
  });
};

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', function(){ window.LTPQrangos(document); });
}else{
  window.LTPQrangos(document);
}


/* "Añadir al carrito" desde las tarjetas del catálogo, sin recargar la página.
   Se usa la API /cart/add.js; el contador de la cabecera se actualiza al vuelo
   y el botón confirma en el sitio. Si algo falla, se envía el formulario normal. */
(function(){
  document.addEventListener('submit', function(ev){
    var forma = ev.target.closest('[data-agregar]');
    if(!forma) return;
    ev.preventDefault();
    var boton = forma.querySelector('button[type=submit]');
    var original = boton ? boton.textContent : '';
    if(boton){ boton.disabled = true; boton.textContent = 'Añadiendo…'; }

    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: new FormData(forma)
    })
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}); })
    .then(function(r){ return r.json(); })
    .then(function(carrito){
      var contador = document.querySelector('.carrito .num');
      if(contador) contador.textContent = carrito.item_count;
      var cabecera = document.querySelector('.carrito');
      if(cabecera) cabecera.classList.add('late');
      if(boton){ boton.textContent = '¡Añadido!'; }
      setTimeout(function(){
        if(boton){ boton.disabled = false; boton.textContent = original; }
        if(cabecera) cabecera.classList.remove('late');
      }, 1600);
    })
    .catch(function(){
      if(boton){ boton.disabled = false; boton.textContent = original; }
      forma.submit(); // red de seguridad: envío clásico
    });
  });
})();
